import {
  Typography,
} from '@material-ui/core';
import {
  FormikErrors, FormikTouched,
} from 'formik';
import React from 'react';
import {
  FieldErrorProps,
} from './types';

const getTouched = (touched: FormikTouched<any>): boolean => {
  let isTouched = false;
  if (Array.isArray(touched)) {
    if (!touched.length) {
      isTouched = false;
    } else {
      isTouched = false;
    }
  } else if (typeof touched === 'boolean') {
    isTouched = touched;
  } else {
    isTouched = false;
  }
  return isTouched;
};

const getError = (errors: FormikErrors<any>): string => {
  let error = '';
  if (Array.isArray(errors)) {
    if (!errors.length) {
      error = '';
    } else if (typeof errors[0] === 'string') {
      [error] = errors;
    } else {
      error = '';
    }
  } else if (typeof errors === 'string') {
    error = errors;
  } else {
    error = '';
  }
  return error;
};

const FieldError: React.FC<FieldErrorProps> = (props) => {
  const {
    errors,
    touched,
  } = props;
  const error = getError(errors);
  const isTouched = getTouched(touched);
  if (!error || !isTouched) {
    return (null);
  }
  return (
    <div
      style={{
        height: 24,
      }}
    >
      <Typography
        variant="subtitle1"
        color="error"
        style={{
          paddingLeft: 16,
        }}
      >
        {error}
      </Typography>
    </div>
  );
};

export default FieldError;
